window.addEventListener('DOMContentLoaded', () => {
    changeDisplay();
  });

  addEventListener('resize', (event) => changeDisplay());

const slider = document.querySelector('.items');
let isDown = false;
let startX;
let scrollLeft;
let scrollRight;

slider.addEventListener('mousedown', (e) => {
  isDown = true;

  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;

});
slider.addEventListener('mouseup', () => {
  isDown = false;

});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 2; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
});


function changeDisplay()
{
  let el = document.querySelector('.collectionsNamesList')
  if (!isOverflown(el))
  {
    el.classList.add('items-flex')
  }
  else{
    el.classList.remove('items-flex')
  }
}

function isOverflown(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}